import AScene from "../../library/ExtendedObjects/AScene.js";
import gameData from "../../gameData.js";
import fuzzbug from "../Fuzzbug.js";
import ABCyaPhaser from "@abcya/abcya_phaser";
import ABCyaLib from "@abcya/abcya_lib";

export default class Intro extends AScene {
  static get KEY() { return 'Intro'; }

  create() {
    gameData.currentScene = "Intro";
    gameData.gameOver = false;
    gameData.gamePaused = false;
    gameData.customizerComplete = false;
    gameData.score = 0;
    gameData.counter = 0;
    gameData.level = 0;
    gameData.totalOutlines = 0;
    gameData.fuzzIndex = 0;

    gameData.fuzzStencil = "",
      gameData.fuzzStencilColor = "",
      gameData.fuzzStencilName = "",
      gameData.fuzzColor = "",
      gameData.fuzzColorName = "",
      gameData.customFuzzbug = false,
      gameData.customReplacementID = 1,
      gameData.customReplacementColor = "",

      this.playJingle();

    this.createIntro();
  }

  playJingle() {
    let counter = 0;
    //console.log(this.sound.sounds);
    for (let i = 0; i < this.sound.sounds.length; i++) {
      //console.log(this.sound.sounds[i].currentMarker.name);
      if (this.sound.sounds[i].currentMarker.name === "jingle_patterns") counter++;
    }
    if (counter === 0) gameData.jingle = this.playSound("jingle_patterns", .2, true);
  }

  createIntro() {
    this.bg = this.addImage(this.mid.x, this.mid.y, "Bckg");

    this.title = this.addImage(this.mid.x, -200, "Logo_Fuzz_Bugs", ABCyaPhaser.Images.LOCALIZATION_ATLAS);

    const pos = ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? {x: this.mid.x, y:415} : {x: this.mid.x + 390, y:278};
    this.playBtn = this.addButton(pos.x, pos.y, "Btn_Play", {}, () => { this.tweenOutIntro(); });
    this.playBtn.setEnabled(false);
    this.playBtn.setAlpha(0);

    this.playSound("title_tweens", .5, false, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    //TODO UPDATE SPINE FOR FUZZBUGS
    this.fb = new fuzzbug(this, -300, this.mid.y + 355, 1, "RunningRight");
    this.fb2 = new fuzzbug(this, -300, this.mid.y + 355, 2, "RunningRight");
    this.fb3 = new fuzzbug(this, this.mid.x * 2 + 300, this.mid.y + 355, 3, "RunningLeft");

    let colArray = [...gameData.fuzzColors];
    this.shuffleArray(colArray);

    this.fb.color = colArray[this.fb.ind].color;
    this.fb2.color = colArray[this.fb2.ind].color;
    this.fb3.color = colArray[this.fb3.ind].color;

    this.fb.paintFuzzbug();
    this.fb2.paintFuzzbug();
    this.fb3.paintFuzzbug();

    this.addTween(this.title, 2000, { y: 260 }, Phaser.Math.Easing.Back.Out);
    this.addTween(this.playBtn, 1000, { alpha: 1, delay: 1500 }, Phaser.Math.Easing.None,
      () => { this.playBtn.setEnabled(true); });
  }

  tweenOutIntro() {
    this.playBtn.setEnabled(false);

    this.fb.leaveGame();
    this.fb2.leaveGame();
    this.fb3.leaveGame();

    this.playSound("click");

    this.addTween(this.title, 1500, { y: -200 }, Phaser.Math.Easing.Back.In,
      () => { this.cleanUp(); });
    this.addTween(this.playBtn, 1500, { alpha: 0 }, Phaser.Math.Easing.None);
  }

  cleanUp() {
    console.log("going to game");

    this.fb.cleanUp();
    this.fb.destroy();
    this.fb = null;
    this.fb2.cleanUp();
    this.fb2.destroy();
    this.fb2 = null;
    this.fb3.cleanUp();
    this.fb3.destroy();
    this.fb3 = null;

    this.title.destroy();
    this.playBtn.destroy();

    this.scene.start("Game");
  }
}